import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/client/components/Product Details/ProductDisplay.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/client/components/Product Details/ProductInfo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/client/components/ProductPageComponents/Avis.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/client/components/ProductPageComponents/GiveYourAvis.jsx");
;
import(/* webpackMode: "eager" */ "/root/mrbuttonv1/client/components/ProductPageComponents/SimilarProducts.jsx");
;
import(/* webpackMode: "eager" */ "/root/mrbuttonv1/client/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/mrbuttonv1/client/node_modules/next/font/google/target.css?{\"path\":\"app/fonts.js\",\"import\":\"Oswald\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"oswald\"}");
